export default {
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}
